import * as $ from "jquery";

export class MarketingScheduleMonth {
    constructor() {
        const self = this;

        $(function () {
            const oldstate = history.state;
            if (oldstate) {
                const day: number = oldstate.day;

                // expand those items
                //console.log("old state: " + JSON.stringify(oldstate));
                $(".itemclass").filter(`[data-day='${day}']`).show();
                $(".showmore").filter(`[data-day='${day}']`).hide();
            }
            $(".dayothermonth").text("");

            $(".showmore").on("click", function () {
                const $showmore = $(this);

                //var stateObj = { day: $showmore.data("day") };
                //console.log("pushing state: " + JSON.stringify(stateObj));
                //history.pushState(stateObj, "");
                self.expandshowmore($showmore);
            });
            $(".itemclass").on("click", function () {
                const $evt = $(this);
                if ($evt.hasClass("itemhidden")) {
                    const day: number = $evt.data("day");
                    const stateObj = { day: day };
                    //console.log("pushing state: " + JSON.stringify(stateObj));
                    history.pushState(stateObj, "");
                }
                const link: string = $evt.data("link");
                window.location.href = link;
            });
        });
    }

    expandshowmore($showmore: JQuery) {
        $showmore.hide()
            .nextAll(".itemhidden")
            .show();
    }
}
